var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-title-component",style:({'text-align': _vm.align})},[_c('span',[_vm._v(_vm._s(this.text))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }